export default __webpack_public_path__ + "static/media/Group_7_moderateToHigh.1d118da8.svg";